import Vue from 'vue'
import Router from 'vue-router'
// import OrdersLayout from '@/views/OrdersLayout'
import NewOrderLayout from '@/views/NewOrderLayout'
import OrdersDeliveryLayout from '@/views/OrdersDeliveryLayout'
import LoginLayout from '@/views/LoginLayout'
import OrdersCollectingLayout from '@/views/OrdersCollectingLayout'
import OverallWorkshopStat from '@/views/OverallWorkshopStat'
import ProductsLayout from '@/views/ProductsLayout'
import PizzaDoughLayout from '../views/PizzaDoughLayout'
import CookLayout from '@/views/CookLayout'
import { permExclude, permExcludeRole } from '@/constants/permissions'
import CourierDeliveryLayout from '@/views/CourierDeliveryLayout'
import Logout from '@/views/Logout'
import StatsAdminLayout from '@/views/StatsAdminLayout'
import StatisticLayout from '@/views/StatisticLayout'

import {
  ROUTE_NAME_ORDER_LOGIN,
  ROUTE_NAME_ORDER_MANAGEMENT,
  ROUTE_NAME_ORDER_DELIVERY,
  ROUTE_NAME_ORDER_COLLECTING,
  ROUTE_NAME_TASKS_PRODUCT,
  ROUTE_NAME_TASKS_ORDER,
  ROUTE_NAME_DELIVERY_COURIER,
  ROUTE_NAME_COURIER_STATS,
  ROUTE_NAME_ADMIN_STATS
} from '@/constants/routes'
import {ROUTE_NAME_ACCOUNTING_WORKERS, ROUTE_NAME_LOGOUT, ROUTE_NAME_WORKSHOP_STATS} from '../constants/routes'
import {USER_ROLE_DELIVERY_COURIER, USER_ROLE_GUEST} from '../constants/roles'
import WorkersAccountingLayout from "../views/WorkersAccountingLayout";
Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: ROUTE_NAME_ORDER_LOGIN,
    component: LoginLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ORDER_LOGIN)
    }
  },
  {
    path: '/orderManagment',
    name: ROUTE_NAME_ORDER_MANAGEMENT,
    component: NewOrderLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ORDER_MANAGEMENT)
    }
  },
  {
    path: '/pizzaDough',
    name: ROUTE_NAME_TASKS_PRODUCT,
    component: PizzaDoughLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_TASKS_PRODUCT)
    }
  },
  {
    path: '/cookOrders',
    name: ROUTE_NAME_TASKS_ORDER,
    component: CookLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_TASKS_ORDER)
    }

  },
  {
    path: '/courierDelivery',
    name: ROUTE_NAME_DELIVERY_COURIER,
    component: CourierDeliveryLayout,
    meta: {
      permissions: permExcludeRole(USER_ROLE_DELIVERY_COURIER)
    }

  },
  {
    path: '/courierStats',
    name: ROUTE_NAME_COURIER_STATS,
    component: StatisticLayout,
    meta: {
      permissions: permExcludeRole(USER_ROLE_DELIVERY_COURIER)
    }
  },
  {
    path: '/deliveryOrder',
    name: ROUTE_NAME_ORDER_DELIVERY,
    component: OrdersDeliveryLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ORDER_DELIVERY)
    }
  },
  {
    path: '/collectingOrder',
    name: ROUTE_NAME_ORDER_COLLECTING,
    component: OrdersCollectingLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ORDER_COLLECTING)
    }
  },
  {
    path: '/stats',
    name: ROUTE_NAME_ADMIN_STATS,
    component: StatsAdminLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ADMIN_STATS)
    }
  },
  {
    path: '/accounting',
    name: ROUTE_NAME_ACCOUNTING_WORKERS,
    component: WorkersAccountingLayout,
    meta: {
      permissions: permExclude(ROUTE_NAME_ACCOUNTING_WORKERS)
    }
  },
  {
    path: '/statsWorkshop',
    name: ROUTE_NAME_WORKSHOP_STATS,
    component: OverallWorkshopStat,
    meta: {
      permissions: permExclude(ROUTE_NAME_WORKSHOP_STATS)
    }
  },
  {
    path: '/logout',
    name: ROUTE_NAME_LOGOUT,
    component: Logout,
    meta: {
      permissions: [
        {
          role: USER_ROLE_GUEST,
          access: false,
          redirect: ROUTE_NAME_ORDER_LOGIN
        }
      ]
    }
  },
  { path: '*', redirect: '/login' }
]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (ROUTE_NAME_ORDER_LOGIN === from.name || (ROUTE_NAME_ORDER_LOGIN === to.name && null !== from.name)) {
    // Поскольку конфигурационные параметры можем считывать только после
    // авторизации, вынуждены перезагружать всю страницу, чтобы плагин
    // инициализировался заново и, как следствие, подключил API с ключами.
    // @todo более изящный способ?
    window.location.reload()
    next(false)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js